// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.notifierContainer[data-v-0821324a] {\n  pointer-events: none;\n  z-index: 9999;\n  position: fixed;\n  left: 8px;\n  right: 8px;\n  bottom: 8px;\n}\n.snackFade[data-v-0821324a] {\n  transition-property: opacity, transform;\n  transition-duration: 0.15s;\n  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);\n  transform-origin: center right;\n}\n.snackFade-enter[data-v-0821324a],\n.snackFade-leave-to[data-v-0821324a] {\n  transform: scale(0.8);\n  opacity: 0;\n}\n", ""]);
// Exports
module.exports = exports;
